import { render, staticRenderFns } from "./fields-db.component.vue?vue&type=template&id=ac16db00"
import script from "./fields-db.component.ts?vue&type=script&lang=ts&external"
export * from "./fields-db.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports